// extracted by mini-css-extract-plugin
export var button = "styles-module--button--049dc";
export var desktop = "1340px";
export var disabledSlash = "styles-module--disabledSlash--8aba3";
export var disabledSlashContainer = "styles-module--disabledSlashContainer--3eef1";
export var giant = "2200px";
export var isSelected = "styles-module--isSelected--de877";
export var isSquare = "styles-module--isSquare--8d5fe";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";